('.--navigation nav>ul').dropDown(el => {
  el.classList.add('--active');
  const dropdown = el.getElementsByClassName('--dropdown');
  if (dropdown.length) {
    dropdown[0].style.display = 'flex';
  }
}, el => {
  el.classList.remove('--active');

  const tags = el.getElementsByTagName('a');
  for (let i = 0; i < tags.length; i++) {
    tags[i].classList.remove('--active');
  }

  const dropdown = el.getElementsByClassName('--dropdown');
  if (dropdown.length) {
    resetLevels();
    dropdown[0].style.display = 'none';
  }
}, 200);

function resetLevels(): void {
  const levels = document.querySelectorAll('.--dropdown .grid-container > div');
  levels.forEach((level: HTMLElement, index: number) => {
    if (index > 0) {
      level.style.display = 'none';
    }
  });
}

import SimpleLightbox from 'simplelightbox';

window.addEventListener('load', () => {

    document.querySelectorAll('.lightbox__container a').forEach((el) => {
      el.classList.remove('pointer-events-none');
    });

    const windowWidth = window.innerWidth;

    if (windowWidth < 1024) {
        const footerItems = document.querySelectorAll('.footer__links .--links');
        if (footerItems.length) {
            footerItems.forEach((item) => {
                const clickEvent = item.getElementsByTagName('h5')[0];
                clickEvent?.addEventListener('click', () => {
                    item.classList.toggle('--active');
                });
            });
        }
    }

    const solarNavigation = document.querySelectorAll('.navigation__columns');
    if (solarNavigation.length) {
        solarNavigation.forEach((item) => {
            const dropDown = item.getElementsByClassName('--dropdown');
            if (dropDown.length) {
                const clickableElements = dropDown[0].getElementsByTagName('a');
                for (let i = 0; i < clickableElements.length; i++) {
                    clickableElements[i].addEventListener('mouseenter', (): void => {
                      event.preventDefault();
                        toggleSubMenu(
                            event,
                            item,
                            'mouseenter',
                            clickableElements[i],
                            clickableElements[i].classList.contains('--has-children')
                        );
                    });

                    clickableElements[i].addEventListener('mouseleave', (): void => {
                        event.preventDefault();
                        toggleSubMenu(
                            event,
                            item,
                            'mouseleave',
                            clickableElements[i],
                            clickableElements[i].classList.contains('--has-children')
                        );
                    });
                }
            }
        });

        function toggleSubMenu(event: Event, rootEl: Element, mouseEvent: string, el: Element, hasChildren: boolean): void {
            if ( ! hasChildren) {
                return;
            }

            const level = el.getAttribute('data-level');
            const subId = el.getAttribute('data-id');

            const levelElement = rootEl.querySelector(`.level-${level}`) as HTMLElement ?? null
            const subMenu = levelElement.querySelector(`div[data-sub='${subId}']`) as HTMLElement ?? null
            const subSubMenu = levelElement.querySelector(`div[data-sub='${subId + 1}']`) as HTMLElement ?? null;

            if (mouseEvent === 'mouseenter') {

                levelElement.style.display = 'block';
                levelElement.querySelectorAll('div').forEach((element) => {
                  element.style.display = 'none';
                });
                subMenu.style.display = 'block';
                if (level === '2') {
                  rootEl.querySelectorAll(`a[data-level="2"]`).forEach((element) => {
                    element.classList.remove('--active');
                  });
                }
              if (level === '3') {
                rootEl.querySelectorAll(`a[data-level="3"]`).forEach((element) => {
                  element.classList.remove('--active');
                });
              }
                el.classList.add('--active');
            }

            if (mouseEvent === 'mouseleave') {
                // Check if the mouse is really leaving the levelElement
                const relatedTarget = (event as MouseEvent).relatedTarget as Node;

                if ( !levelElement.contains(relatedTarget)) {
                    el.classList.remove('--active');
                    levelElement.style.display = 'none';
                    subMenu.style.display = 'none';
                    if (subSubMenu) {
                        subSubMenu.style.display = 'none';
                    }
                }
            }
        }
    }

    let gallery = new SimpleLightbox('.lightbox__container a', {
        maxZoom: 5,
        loop: false,
        overlayOpacity: 0.45,
        navText: ['', ''],
        closeText: '',
        showCounter: false,
    });

    gallery.on('changed.simplelightbox', function (e: Event) {
        const mediaGallery = document.getElementById('mediaGallery');
        const blazeSlider = mediaGallery['blazeSlider'];

        const thumbnailGallery = document.getElementById('thumbnailGallery');
        const blazeSliderThumbnail = thumbnailGallery['blazeSlider'];

        const index = (e.target as Element).getAttribute('data-index');

        blazeSlider.slideTo(index);
        blazeSliderThumbnail.slideTo(index);
    });

    dataTabs();
});

function dataTabs(): void {
    const tabElements = document.querySelectorAll('[data-role="tabs"]');
    for (let i = 0; i < tabElements.length; i++) {
        const tabElement = tabElements[i];
        const tabItems = tabElement.querySelectorAll('nav > button');
        const tabContents = tabElement.querySelectorAll('div > section');

        tabItems[0].classList.add('--active');
        tabContents[0].classList.add('--active');

        for (let j = 0; j < tabItems.length; j++) {
            const tabItem = tabItems[j];
            tabItem.addEventListener('click', () => {
                for (let k = 0; k < tabItems.length; k++) {
                    tabItems[k].classList.remove('--active');
                    tabContents[k].classList.remove('--active');
                }

                tabItem.classList.add('--active');
                tabContents[j].classList.add('--active');
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('dialog[data-modal]');
  modals.forEach((modal) => {
    const modalTarget = modal as HTMLDialogElement;
    const modalId = modal.getAttribute('data-modal');
    const modalButton = document.querySelector(`[data-modal-trigger="${modalId}"]`);

    modalButton.addEventListener('click', () => {
      modalTarget.showModal();
    });
    modalTarget.addEventListener('click', (event) => {
      if (event.target === modalTarget) {
        modalTarget.close();
      }
    });

    const closeButtons = modalTarget.querySelectorAll('.close');
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        modalTarget.close();
      });
    });
  });

  document.querySelectorAll('.collapsible__trigger').forEach(button => {
    button.addEventListener('click', function() {
      this.classList.toggle('active');
      const content = this.nextElementSibling;

      if (content.style.maxHeight) {
        // If maxHeight is set, slide up
        content.style.maxHeight = null;
      } else {
        // Set maxHeight to scrollHeight for slide down effect
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });

});
